const graphDataTypes = {
  deskCount: 'DESK_COUNT',
  deskUtilization: 'DESK_UTILIZATION',
};

export default graphDataTypes;
